import React from 'react';

const SharedContext = React.createContext(null);

export default SharedContext;
